import { NoticeBar } from '@hb/coffee';
import {
  Vue, Component,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import type { ApplyChannelData } from '@/api/apply-product/types';
import { AdjustTypeEnum } from '@/dict/quotaIncrease-type';
import { confirmDialog } from '@/components/dialog';
import type { AntiFraudConfigType } from '../../types';

const style = require('./index.module.scss') as Dictionary;

const ApplyProductStore = namespace('applyProduct');

@Component
export default class TopNotice extends Vue {
  /** 渠道对应提示 */
  @ApplyProductStore.State notice!: string;

  @ApplyProductStore.State antiFraudConfig!: AntiFraudConfigType | null;

  @ApplyProductStore.State channel!: ApplyChannelData;

  // 获取渠道临时额度数据
  private get tempTip():string {
    const { adjustQuota } = this.channel || {};
    const { adjustType, adjustValue = 0, tempCreditExpiryTime = '' } = adjustQuota || {};
    if (Number(adjustValue) && adjustType === AdjustTypeEnum.TEMP) {
      return `您的临时额度${adjustValue}元将在${tempCreditExpiryTime}失效，请尽快借出`;
    }
    return '';
  }

  private get visible() {
    const { topTip } = this.antiFraudConfig || {};
    /** 当跑马灯配置返回后，当tipShow是false or tipText是空时，不展示通告栏 */
    if (topTip && (topTip.tipShow === false || !topTip.tipText)) {
      return false;
    }

    return true;
  }

  // 获取防诈骗提示文案
  private get antiFraudText() {
    // 获取防诈骗提示相关配置
    const { topTip } = this.antiFraudConfig || {};
    const { tipShow = false, tipText = '' } = topTip || {};
    return tipShow ? tipText : '';
  }

  // 根据不同优先级 判断是否显示右侧箭头
  private get isShowArrow() {
    return !!(this.tempTip && this.noticeText === this.tempTip);
  }

  /** 通告栏文案
   * 优先级：额度续期 > 临时额度 > 渠道提示文案 > 防诈骗提示
  */
  private get noticeText(): string {
    let text = '';
    const { creditExpireRenewalTip = '' } = this.channel || {};

    if (creditExpireRenewalTip) {
      text = creditExpireRenewalTip;
    } else if (this.tempTip) {
      text = this.tempTip;
    } else {
      text = this.notice || this.antiFraudText;
    }

    return text;
  }

  private onClickNoticeBar() {
    if (this.tempTip) {
      confirmDialog.open({
        title: '临时额度说明',
        content: (
          <div>
            额度组成：您的可借额度由固定额度和临时额度组成。<br />
            额度使用：借款时会优先使用固定额度，超过固定额度部分则会使用临时额度。<br />
            额度恢复：还款成功后仅恢复固定额度，临时额度不再恢复。
          </div>
        ),
        confirmText: '知道了',
        ubtName: '',
        contentStyle: 'text-align: left',
      });
    }
  }

  private render() {
    if (this.visible) {
      return (
      <NoticeBar
      /**
       * 保留key属性，用于控制滚动效果
       * 当通知文本变化时，通过改变key值强制组件重新渲染
       * 确保滚动动画能够正常重启和显示
       */
        key={this.noticeText}
        text={this.noticeText}
        show-arrow={this.isShowArrow}
        show-icon={false}
        scrollable={true}
        class={style.applyTopNotice}
        onClick={this.onClickNoticeBar.bind(this)}
      />
      );
    }

    return null;
  }
}
